<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Guia do Evento</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Guia do Evento</div>
        </div>
      </div>

      <div class="appui-tabs">
        <button v-for="t in tabs" :key="t.key" :class="{ 'is-active': activeTab === t.key }" @click="activeTab = t.key">
          <i :class="t.icon" style="margin-right:5px"></i>{{ t.label }}
        </button>
      </div>

      <!-- HOTÉIS -->
      <section v-if="activeTab === 'hoteis'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Hotéis</span></div>
          <div class="appui-card-toolbar-right"><button class="appui-btn appui-btn--primary" @click="openHotel()">+ Novo hotel</button></div>
        </div>
        <div v-if="!hotels.length" class="appui-inline-empty">Nenhum hotel cadastrado.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Hotel</th><th>Endereço</th><th style="width:90px">Fotos</th><th style="width:150px;text-align:right">Ações</th></tr></thead>
          <tbody>
            <tr v-for="h in hotels" :key="h.id">
              <td>
                <div style="display:flex;align-items:center;gap:11px">
                  <span class="appui-avatar" style="width:38px;height:38px;font-size:15px">
                    <img v-if="h.photos && h.photos.length" :src="h.photos[0].photo"><template v-else><i class="bx bx-building-house"></i></template>
                  </span>
                  <div>
                    <div style="font-weight:500;color:#495057">{{ h.name }}</div>
                    <div v-if="h.has_restaurant" style="font-size:11px;color:#74788d"><i class="mdi mdi-silverware-fork-knife"></i> {{ h.restaurant_name || 'Restaurante' }}</div>
                  </div>
                </div>
              </td>
              <td style="color:#74788d">{{ h.address || '—' }}</td>
              <td style="color:#74788d">{{ (h.photos || []).length }}</td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn" style="margin-right:6px" @click="openHotel(h)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="removeHotel(h)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- TRANSFERS -->
      <section v-if="activeTab === 'transfers'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Transfers</span></div>
          <div class="appui-card-toolbar-right"><button class="appui-btn appui-btn--primary" @click="openTransfer()">+ Novo transfer</button></div>
        </div>
        <div v-if="!transfers.length" class="appui-inline-empty">Nenhum transfer cadastrado.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Descrição</th><th style="width:80px">Tipo</th><th>Quando</th><th>Ponto de encontro</th><th style="width:150px;text-align:right">Ações</th></tr></thead>
          <tbody>
            <tr v-for="t in transfers" :key="t.id">
              <td style="font-weight:500;color:#495057">{{ t.name }}</td>
              <td><span class="appui-badge" :class="t.type_transfer === 2 ? '' : 'appui-badge--blue'">{{ t.type_transfer === 2 ? 'Volta' : 'Ida' }}</span></td>
              <td style="color:#74788d">{{ t.date_hour || '—' }}</td>
              <td style="color:#74788d">{{ t.meeting_point || '—' }}</td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn" style="margin-right:6px" @click="openTransfer(t)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="removeTransfer(t)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- WI-FI -->
      <section v-if="activeTab === 'wifi'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Redes Wi-Fi</span></div>
          <div class="appui-card-toolbar-right"><button class="appui-btn appui-btn--primary" @click="openWifi()">+ Nova rede</button></div>
        </div>
        <div v-if="!wifis.length" class="appui-inline-empty">Nenhuma rede cadastrada.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Rede</th><th>Local</th><th>Senha</th><th style="width:150px;text-align:right">Ações</th></tr></thead>
          <tbody>
            <tr v-for="w in wifis" :key="w.id">
              <td style="font-weight:500;color:#495057"><i class="mdi mdi-wifi" style="color:#556ee6"></i> {{ w.name }}</td>
              <td style="color:#74788d">{{ w.local_wifi || '—' }}</td>
              <td><code style="background:#f3f4f6;border-radius:5px;padding:2px 8px;color:#495057">{{ w.password || '—' }}</code></td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn" style="margin-right:6px" @click="openWifi(w)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="removeWifi(w)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- ATIVIDADES -->
      <section v-if="activeTab === 'atividades'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Atividades <small style="font-weight:400;color:#74788d">— com inscrição pelo app</small></span></div>
          <div class="appui-card-toolbar-right"><button class="appui-btn appui-btn--primary" @click="openActivity()">+ Nova atividade</button></div>
        </div>
        <div v-if="!activities.length" class="appui-inline-empty">Nenhuma atividade cadastrada.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Atividade</th><th>Quando</th><th>Local</th><th style="width:100px">Inscritos</th><th style="width:80px">Ativa</th><th style="width:230px;text-align:right">Ações</th></tr></thead>
          <tbody>
            <tr v-for="a in activities" :key="a.id">
              <td style="font-weight:500;color:#495057">{{ a.name }}</td>
              <td style="color:#74788d">{{ a.date_hour || '—' }}</td>
              <td style="color:#74788d">{{ a.local_activitie || a.local || '—' }}</td>
              <td><span class="appui-badge appui-badge--blue">{{ a.participants_count || 0 }}</span></td>
              <td><button class="appui-switch" :class="{ 'is-on': a.status }" @click="toggleActivity(a)"><span class="knob"></span></button></td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn appui-tbtn--primary" style="margin-right:6px" title="Exportar inscritos (Excel)" @click="exportActivity(a)"><i class="mdi mdi-download"></i> Inscritos</button>
                <button class="appui-tbtn" style="margin-right:6px" @click="openActivity(a)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="removeActivity(a)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- MAPA -->
      <section v-if="activeTab === 'mapa'" class="appui-card" style="padding:22px 24px">
        <h2 class="appui-sec-title">Mapa do evento</h2>
        <p class="appui-sec-sub">Imagem ou PDF que o participante abre no app.</p>
        <div style="display:flex;gap:10px;max-width:640px">
          <input type="url" class="appui-input" v-model="mapUrl" placeholder="https://...">
          <button class="appui-btn appui-btn--primary" style="flex:none" :disabled="savingMap" @click="saveMap()">Salvar</button>
        </div>
        <div v-if="mapUrl" style="margin-top:12px"><a :href="mapUrl" target="_blank" rel="noopener" style="font-size:12.5px"><i class="mdi mdi-open-in-new"></i> Abrir mapa atual</a></div>
      </section>
    </div>

    <!-- Modal Hotel -->
    <b-modal v-model="hotelModal" :title="hotelForm.id ? 'Editar hotel' : 'Novo hotel'" size="lg" hide-footer>
      <form @submit.prevent="saveHotel()">
        <div class="form-group"><label>Nome *</label><input type="text" class="form-control" v-model="hotelForm.name" required></div>
        <div class="form-group"><label>Endereço</label><input type="text" class="form-control" v-model="hotelForm.address"></div>
        <div class="form-group"><label>Acomodações / observações</label><textarea class="form-control" rows="2" v-model="hotelForm.accommodation"></textarea></div>
        <label class="appui-perm-row" style="margin-bottom:12px">
          <span><i class="mdi mdi-silverware-fork-knife"></i> Possui restaurante</span>
          <button type="button" class="appui-switch" :class="{ 'is-on': hotelForm.has_restaurant }" @click="hotelForm.has_restaurant = hotelForm.has_restaurant ? 0 : 1"><span class="knob"></span></button>
        </label>
        <div v-if="hotelForm.has_restaurant" class="row">
          <div class="form-group col-sm-6"><label>Nome do restaurante</label><input type="text" class="form-control" v-model="hotelForm.restaurant_name"></div>
          <div class="form-group col-sm-6"><label>Café da manhã</label><input type="text" class="form-control" v-model="hotelForm.restaurant_breakfast" placeholder="ex: 6h às 10h"></div>
          <div class="form-group col-sm-6"><label>Almoço</label><input type="text" class="form-control" v-model="hotelForm.restaurant_lunch"></div>
          <div class="form-group col-sm-6"><label>Jantar</label><input type="text" class="form-control" v-model="hotelForm.restaurant_dinner"></div>
        </div>
        <div v-if="hotelForm.id" class="form-group">
          <label>Fotos</label>
          <div class="d-flex flex-wrap mb-2">
            <div v-for="p in hotelForm.photos" :key="p.id" class="position-relative mr-2 mb-2">
              <img :src="p.photo" style="width:90px;height:60px;object-fit:cover" class="rounded">
              <button type="button" class="btn btn-sm btn-danger position-absolute" style="top:-8px;right:-8px;padding:0 5px" @click="removeHotelPhoto(p)">×</button>
            </div>
          </div>
          <input type="file" accept="image/*" ref="hotelPhoto" style="display:none" @change="onHotelPhoto">
          <button type="button" class="appui-btn appui-btn--ghost appui-btn--sm" @click="$refs.hotelPhoto.click()"><i class="mdi mdi-image-plus mr-1"></i> Adicionar foto</button>
        </div>
        <p v-else class="text-muted" style="font-size:12px">Salve o hotel para adicionar fotos.</p>
        <div class="text-right mt-3">
          <button type="button" class="btn btn-light mr-2" @click="hotelModal = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button>
        </div>
      </form>
    </b-modal>

    <!-- Modal Transfer -->
    <b-modal v-model="transferModal" :title="transferForm.id ? 'Editar transfer' : 'Novo transfer'" hide-footer>
      <form @submit.prevent="saveTransfer()">
        <div class="form-group"><label>Descrição *</label><input type="text" class="form-control" v-model="transferForm.name" required></div>
        <div class="row">
          <div class="form-group col-sm-6"><label>Tipo *</label><select class="custom-select" v-model.number="transferForm.type_transfer"><option :value="1">Ida</option><option :value="2">Volta</option></select></div>
          <div class="form-group col-sm-6"><label>Local</label><input type="text" class="form-control" v-model="transferForm.local"></div>
        </div>
        <div class="form-group"><label>Data e horários</label><input type="text" class="form-control" v-model="transferForm.date_hour" placeholder="ex: 01/08 às 14h"></div>
        <div class="form-group"><label>Ponto de encontro</label><input type="text" class="form-control" v-model="transferForm.meeting_point"></div>
        <div class="form-group"><label>Observações</label><textarea class="form-control" rows="2" v-model="transferForm.obs"></textarea></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="transferModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>

    <!-- Modal Wi-Fi -->
    <b-modal v-model="wifiModal" :title="wifiForm.id ? 'Editar rede' : 'Nova rede'" hide-footer>
      <form @submit.prevent="saveWifi()">
        <div class="form-group"><label>Nome da rede *</label><input type="text" class="form-control" v-model="wifiForm.name" required></div>
        <div class="form-group"><label>Local</label><input type="text" class="form-control" v-model="wifiForm.local_wifi"></div>
        <div class="form-group"><label>Senha</label><input type="text" class="form-control" v-model="wifiForm.password"></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="wifiModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>

    <!-- Modal Atividade -->
    <b-modal v-model="activityModal" :title="activityForm.id ? 'Editar atividade' : 'Nova atividade'" hide-footer>
      <form @submit.prevent="saveActivity()">
        <div class="form-group"><label>Descrição *</label><input type="text" class="form-control" v-model="activityForm.name" required></div>
        <div class="row">
          <div class="form-group col-sm-6"><label>Localização</label><input type="text" class="form-control" v-model="activityForm.local"></div>
          <div class="form-group col-sm-6"><label>Local da atividade</label><input type="text" class="form-control" v-model="activityForm.local_activitie"></div>
        </div>
        <div class="form-group"><label>Data e horário</label><input type="text" class="form-control" v-model="activityForm.date_hour" placeholder="ex: 02/08 às 10h"></div>
        <div class="form-group"><label>Observações</label><textarea class="form-control" rows="2" v-model="activityForm.obs"></textarea></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="activityModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-guide',
  data () {
    return {
      activeTab: 'hoteis',
      tabs: [
        { key: 'hoteis', label: 'Hotéis', icon: 'bx bx-building-house' },
        { key: 'transfers', label: 'Transfers', icon: 'bx bx-bus' },
        { key: 'wifi', label: 'Wi-Fi', icon: 'mdi mdi-wifi' },
        { key: 'atividades', label: 'Atividades', icon: 'bx bx-run' },
        { key: 'mapa', label: 'Mapa', icon: 'bx bx-map-alt' }
      ],
      hotels: [],
      transfers: [],
      wifis: [],
      activities: [],
      mapUrl: '',
      savingMap: false,
      saving: false,
      hotelModal: false,
      hotelForm: {},
      transferModal: false,
      transferForm: {},
      wifiModal: false,
      wifiForm: {},
      activityModal: false,
      activityForm: {}
    }
  },
  mounted () { this.loadAll() },
  methods: {
    loadAll () {
      services.listGuideHotels().then(r => { this.hotels = r.data.data }).catch(() => {})
      services.listTransfers().then(r => { this.transfers = r.data.data }).catch(() => {})
      services.listWifi().then(r => { this.wifis = r.data.data }).catch(() => {})
      services.listActivities().then(r => { this.activities = r.data.data }).catch(() => {})
      services.getAppSettings().then(r => { this.mapUrl = r.data.data.map_event || '' }).catch(() => {})
    },
    // Hotéis
    openHotel (h) { this.hotelForm = h ? { ...h, photos: [...(h.photos || [])] } : { name: '', has_restaurant: 0, photos: [] }; this.hotelModal = true },
    async saveHotel () {
      this.saving = true
      try {
        const p = { ...this.hotelForm }
        delete p.photos
        if (this.hotelForm.id) await services.updateGuideHotel(this.hotelForm.id, p)
        else await services.createGuideHotel(p)
        this.hotelModal = false
        successMessage('Hotel salvo.', 2000)
        this.reloadHotels()
      } catch (e) { errorMessage('Falha ao salvar hotel.', 3000) } finally { this.saving = false }
    },
    async onHotelPhoto (e) {
      const f = e.target.files[0]
      if (!f || !this.hotelForm.id) return
      const loader = this.$loading.show()
      try {
        const r = await services.uploadGuideHotelPhoto(this.hotelForm.id, f)
        this.hotelForm.photos.push(r.data.data)
        this.reloadHotels()
      } catch (err) { errorMessage('Falha ao enviar foto.', 3000) } finally {
        loader.hide()
        if (this.$refs.hotelPhoto) this.$refs.hotelPhoto.value = ''
      }
    },
    async removeHotelPhoto (p) {
      try {
        await services.deleteGuideHotelPhoto(this.hotelForm.id, p.id)
        this.hotelForm.photos = this.hotelForm.photos.filter(x => x.id !== p.id)
        this.reloadHotels()
      } catch (e) { errorMessage('Falha ao remover foto.', 3000) }
    },
    async removeHotel (h) {
      if (!(await this.confirm(`Remover "${h.name}"?`))) return
      try { await services.deleteGuideHotel(h.id); this.reloadHotels() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    reloadHotels () { services.listGuideHotels().then(r => { this.hotels = r.data.data }) },
    // Transfers
    openTransfer (t) { this.transferForm = t ? { ...t } : { name: '', type_transfer: 1 }; this.transferModal = true },
    async saveTransfer () {
      this.saving = true
      try {
        if (this.transferForm.id) await services.updateTransfer(this.transferForm.id, this.transferForm)
        else await services.createTransfer(this.transferForm)
        this.transferModal = false
        successMessage('Transfer salvo.', 2000)
        services.listTransfers().then(r => { this.transfers = r.data.data })
      } catch (e) { errorMessage('Falha ao salvar transfer.', 3000) } finally { this.saving = false }
    },
    async removeTransfer (t) {
      if (!(await this.confirm(`Remover "${t.name}"?`))) return
      try { await services.deleteTransfer(t.id); services.listTransfers().then(r => { this.transfers = r.data.data }) } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    // Wi-Fi
    openWifi (w) { this.wifiForm = w ? { ...w } : { name: '' }; this.wifiModal = true },
    async saveWifi () {
      this.saving = true
      try {
        if (this.wifiForm.id) await services.updateWifi(this.wifiForm.id, this.wifiForm)
        else await services.createWifi(this.wifiForm)
        this.wifiModal = false
        successMessage('Rede salva.', 2000)
        services.listWifi().then(r => { this.wifis = r.data.data })
      } catch (e) { errorMessage('Falha ao salvar rede.', 3000) } finally { this.saving = false }
    },
    async removeWifi (w) {
      if (!(await this.confirm(`Remover "${w.name}"?`))) return
      try { await services.deleteWifi(w.id); services.listWifi().then(r => { this.wifis = r.data.data }) } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    // Atividades
    openActivity (a) { this.activityForm = a ? { ...a } : { name: '' }; this.activityModal = true },
    async saveActivity () {
      this.saving = true
      try {
        if (this.activityForm.id) await services.updateActivity(this.activityForm.id, this.activityForm)
        else await services.createActivity(this.activityForm)
        this.activityModal = false
        successMessage('Atividade salva.', 2000)
        services.listActivities().then(r => { this.activities = r.data.data })
      } catch (e) { errorMessage('Falha ao salvar atividade.', 3000) } finally { this.saving = false }
    },
    async toggleActivity (a) { try { await services.changeActivityStatus(a.id); a.status = a.status ? 0 : 1 } catch (e) { errorMessage('Falha ao alterar status.', 3000) } },
    async removeActivity (a) {
      if (!(await this.confirm(`Remover "${a.name}"?`))) return
      try { await services.deleteActivity(a.id); services.listActivities().then(r => { this.activities = r.data.data }) } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async exportActivity (a) {
      const loader = this.$loading.show()
      try {
        const res = await services.exportActivityParticipants(a.id)
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = `inscritos-${a.id}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (e) { errorMessage('Falha ao exportar inscritos.', 3000) } finally { loader.hide() }
    },
    // Mapa
    async saveMap () {
      this.savingMap = true
      try {
        await services.updateAppInfo({ map_event: this.mapUrl })
        successMessage('Mapa atualizado.', 2000)
      } catch (e) { errorMessage('Falha ao salvar mapa.', 3000) } finally { this.savingMap = false }
    },
    confirm (msg) { return this.$bvModal.msgBoxConfirm(msg, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' }) }
  }
}
</script>
